export const EVENTO_ROUTE = '/passport_20260626';
